import React, { useEffect } from 'react';
import FormTextField from '../../../../components/FormTextField';
import { Accordion, AccordionDetails, AccordionSummary, Button, Checkbox, Dialog, DialogActions, MenuItem, Stack, Typography, useTheme } from '@mui/material';
import { buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import { Formik, Form, FieldArray } from 'formik';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import ModalHeader from '../../../../components/ModalHeader';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import { showmessage } from '../../../../utils/toastr';
import { setLoading } from '../../../../redux/features/appSlice';
import appapi from '../../../../api/apiClient';
import { useState } from 'react';
import UserDetails from './UserDetails';
import PhoneTextField from '../../../../components/PhoneTextField';
import { matchIsValidTel } from 'mui-tel-input';
import FormSelectField from '../../../../components/FormSelectField';
import { CancelToken } from 'apisauce';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

const validationSchema = yup.object({
  name: yup.string('Full Name').min(3, 'Full Name should be atleast 3 characters').max(100, 'Maximum Character Limit 100').required(' '),
  address: yup.string('Address').min(1, 'Address should be atleast 1 character').max(300, 'Maximum Character Limit 300').required(' '),
  email: yup
    .string('Email')
    .matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'Email is Invalid')
    .trim()
    .nullable()
    .required(' '),
  phone: yup
    .string('Phone Number')
    .required()
    .test('is-valid-number', 'Mobile Number is Invalid', (value) => {
      if (value) {
        return matchIsValidTel(value);
      }

      return false;
    }),
  traderListAccess: yup.string('Trader list access'),
  country: yup.string('Country Name').required(' '),
  designation: yup.string('Designation').required(' ').min(3, 'Designation should be atleast 3 characters').max(50, 'Maximum Character Limit 50'),
  roleTemplateId: yup.string('role').required(' '),
});

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '560px',
    height: '100%',
    borderRadius: '4px',
    maxWidth: '736px',
    maxHeight: 'calc(100%)',
    // overflow: 'hidden'
  },
};

const sx2 = {
  '& .MuiPaper-root-MuiAccordion-root': {
    width: '100%',
    backgroundColor: 'red'
  },
}

export default function AddEditUser({ modelOpen, onModelHandleClose, openRolePrivilage, user, type }) {
  const formRef = useRef();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { countryList } = useSelector((state) => state.layout);
  const { userId, companyDetails } = useSelector((state) => state.auth);
  const userDetails = useSelector((state) => state.auth).user;
  const [roleList, setRoleList] = useState([]);
  const [role, setRole] = useState(null);
  const [expanded, setExpanded] = useState('panel1');

  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  let source = CancelToken.source();

  const getRoleList = async () => {
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(`user-management/listRole/${userDetails?.type}`, {}, {
      cancelToken: source.token
    });
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setRoleList(data.response || []);
      } else {
        setRoleList([]);
      }
    }
  };

  const getUtcOffset  = (date) => {
    return moment(date).subtract(moment(date).utcOffset(),'minutes').utc()
  }


  useEffect(() => {
    getRoleList();
    
    return () => {
      if (source) {
        source.cancel();
      }
    }
  }, []);

  const handleAddUser = async (values) => {
    dispatch(setLoading(true));
    const payload = {
      ...values,
      companyId: companyDetails._id,
      modules: values.role.modules
    };
    delete payload.role;
    const response = await appapi.post(`/user-management`, payload);
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        onModelHandleClose(true);
        showmessage(data.message);
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  const handleEditUser = async (values) => {
    const payload = {
      ...values,
      companyId: companyDetails._id,
      modules: values.role.modules,
      roleId: user?.roleId?._id
    };
    delete payload.role;
    dispatch(setLoading(true));
    const response = await appapi.put(`user-management/${user?._id}`, payload);
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        onModelHandleClose(true);
        showmessage(data.message);
        // dispatch(initGodownList());
      } else {
        showmessage(data.message, 'error');
      }
      dispatch(setLoading(false));
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  const handleChangeAcc = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };



  return (
    <Dialog
      sx={sx}
      open={modelOpen}
      PaperProps={{ sx: { position: 'fixed', top: 0, right: 0, m: 0 } }}
    >
      <Stack
        // className="!h-[100%]"
        style={{ backgroundColor: '#FFFFFF' }}
      >
        <ModalHeader
          label={type === 'add' ? t('Add user') : t('Edit User')}
          onClose={() => onModelHandleClose(false)}
        />
        <Stack
          style={{ backgroundColor: '#8993AC26', width: '100%', height: '2px' }}
          className=""
        />

        <Formik
          innerRef={formRef}
          enableReinitialize={false}
          initialValues={{
            phone: (user?.phoneCode || '') + (user?.phoneNumber || ''),
            phoneCode: user?.phoneCode,
            name: user?.name || '',
            email: user?.email || '',
            phoneNumber: user?.phoneNumber || '',
            email: user?.email || '',
            designation: user?.designation || '',
            country: user?.country || '',
            roleTemplateId: user?.roleId?.roleTemplateId || '',
            address: user?.address || '',
            role: user?.roleId || null
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            if (type === 'add') {
              handleAddUser(values);
            } else {
              handleEditUser(values);
            }
          }}
        >
          {({ name, values, touched, errors, handleChange, handleBlur, isValid, dirty, setFieldValue }) => (
            <Form autoComplete="off">
              <Stack sx={{ backgroundColor: '#F2F3F580', border: '1px solid #8993AC26' }} className='rounded-lg p-4 m-4'>
                <Typography
                  className="fw-regular ff-Roboto fs-16"
                  color={text}
                >
                  {t('Roles & permissions')}
                </Typography>
                <Typography
                  className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                  color={textLight}
                >
                  {t('Some info may be visible to other people using ZeroEmission services')}
                </Typography>
                <Stack
                  style={{}}
                  className=""
                >
                  <Stack>
                    <FormTextField
                      placeholder={t('Select role')}
                      outlineLabel={t('Select role')}
                      fullWidth
                      id={'roleTemplateId'}
                      name="roleTemplateId"
                      requiredMark={true}
                      select
                      onSelect={(e) => {
                        // setRole(roleList.filter(res => res._id === e)[0])
                        setFieldValue('role', roleList.filter(res => res._id === e)[0]);
                      }}
                    >
                      {roleList?.map((item) => (
                        <MenuItem
                          key={item._id}
                          value={item._id}
                        >
                          <div style={{ textTransform: 'capitalize' }}>{item.roleName}</div>
                        </MenuItem>
                      ))}
                    </FormTextField>
                    {/* <Typography
                    onClick={() => {
                      if (roleId) {
                        openRolePrivilage(roleId);
                      }
                    }}
                    style={{ cursor: 'pointer' }}
                    sx={{ marginBottom: '10px !important' }}
                    className="fw-medium ff-Roboto fs-12"
                    color={roleId ? theme.palette.primary.main : textLight}
                  >
                    Click to See Role Privileges
                  </Typography> */}
                  </Stack>

                </Stack>

                <Stack>
                  {
                    (values?.role?.modules || [])?.map((m, index) => (<Accordion
                      key={index}
                      expanded={expanded === `panel${index}`} onChange={handleChangeAcc(`panel${index}`)}
                      style={{ width: '100%', border: 'none' }}
                    >
                      <AccordionSummary

                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        sx={{ backgroundColor: '#8993AC1A', color: theme.palette.primary.text }}
                      >
                        <Typography className='!text-sm font-medium' color={theme.palette.primary.text}>{t(`${m?.moduleGroup}`)}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Stack direction={'row'}>
                          <Stack flex={4}></Stack>
                          <Stack flex={2} alignItems='center' justifyContent='center' ><Typography color={theme.palette.primary.text} className='!text-xs'>{t('View')}</Typography></Stack>
                          <Stack flex={2} alignItems='center' justifyContent='center'><Typography color={theme.palette.primary.text} className='!text-xs'>{t('Add')}</Typography></Stack>
                          <Stack flex={2} alignItems='center' justifyContent='center'><Typography color={theme.palette.primary.text} className='!text-xs'>{t('Modify')}</Typography></Stack>
                          <Stack flex={2} alignItems='center' justifyContent='center'><Typography color={theme.palette.primary.text} className='!text-xs'>{t('Archive')}</Typography></Stack>
                        </Stack>
                        {m?.permission.map((p, pIndex) => <Stack key={pIndex} direction={'row'}>
                          <Stack flex={4} justifyContent='center'>
                            <Typography color={theme.palette.primary.text} className='!text-xs'>{t(p?.moduleName)}</Typography>
                          </Stack>
                          <Stack flex={2} alignItems='center' justifyContent='center'>
                            {p.viewAccess === '2' ? '-' :
                              <Checkbox
                                disabled={values?.role.roleName === 'admin'}
                                checked={p.viewAccess === '1'}
                                onChange={(evt) => {
                                  setFieldValue(`role.modules[${index}].permission[${pIndex}].viewAccess`, evt.target.checked ? '1' : '0');
                                  if (!evt.target.checked) {
                                    if (p.addAccess !== '2') {
                                      setFieldValue(`role.modules[${index}].permission[${pIndex}].addAccess`,  '0');
                                    }
                                    if (p.editAccess !== '2') {
                                      setFieldValue(`role.modules[${index}].permission[${pIndex}].editAccess`,  '0');
                                    }
                                    if (p.archiveAccess !== '2') {
                                      setFieldValue(`role.modules[${index}].permission[${pIndex}].archiveAccess`,  '0');
                                    }
                                  }
                                }}
                              />}
                          </Stack>
                          <Stack flex={2} alignItems='center' justifyContent='center'>
                            {p.addAccess === '2' ? '-' : <Checkbox
                              disabled={values?.role.roleName === 'admin' || p.viewAccess !== '1'}
                              checked={p.addAccess === '1'}
                              onChange={(evt) => {
                                setFieldValue(`role.modules[${index}].permission[${pIndex}].addAccess`, evt.target.checked ? '1' : '0');
                              }}
                            />}
                          </Stack>
                          <Stack flex={2} alignItems='center' justifyContent='center'>
                            {p.editAccess === '2' ? '-' : <Checkbox
                              disabled={values?.role.roleName === 'admin' || p.viewAccess !== '1'}
                              checked={p.editAccess === '1'}
                              onChange={(evt) => {
                                setFieldValue(`role.modules[${index}].permission[${pIndex}].editAccess`, evt.target.checked ? '1' : '0');
                              }}
                            />}
                          </Stack>
                          <Stack flex={2} alignItems='center' justifyContent='center'>
                            {p.archiveAccess === '2' ? '-' : <Checkbox
                              disabled={values?.role.roleName === 'admin' || p.viewAccess !== '1'}
                              checked={p.archiveAccess === '1'}
                              onChange={(evt) => {
                                setFieldValue(`role.modules[${index}].permission[${pIndex}].archiveAccess`, evt.target.checked ? '1' : '0');
                              }}
                            />}
                          </Stack>
                        </Stack>)}

                      </AccordionDetails>
                    </Accordion>))}

                </Stack>
              </Stack>
              <Stack
                style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                className="m-[15px] p-[16px]"
              >
                <Typography
                  className="fw-regular ff-Roboto fs-16"
                  color={text}
                >
                  {t('Basic information')}
                </Typography>
                <Typography
                  className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                  color={textLight}
                >
                  {t('Some info may be visible to other people using ZeroEmission services')}
                </Typography>
                <Stack>
                  <FormTextField
                    outlineLabel={t('Full name')}
                    name="name"
                    requiredMark={true}
                    onlyAlpha={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 101 }}
                  />
                </Stack>
                <Stack>
                  <FormTextField
                    outlineLabel={t('Designation')}
                    name="designation"
                    requiredMark={true}
                    onlyAlpha={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 51 }}
                  />
                </Stack>
              </Stack>
              <Stack
                style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                className="m-[15px] p-[16px]"
              >
                <Typography
                  className="fw-regular ff-Roboto fs-16"
                  color={text}
                >
                  {t('Contact information')}
                </Typography>
                <Typography
                  className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                  color={textLight}
                >
                  {t('Some info may be visible to other people using ZeroEmission services')}
                </Typography>
                <Stack>
                  <Stack>
                    <FormTextField
                      outlineLabel={t('Email')}
                      name="email"
                      requiredMark={true}
                      whiteSpace={true}
                      inputProps={{ maxLength: 50 }}
                      lowerCase={true}
                      disabled={type === 'edit' ? true : false}
                    />
                  </Stack>
                </Stack>
                <Stack>
                  <FormSelectField
                    name="country"
                    label={`${t('Country')} *`}
                    onSelect={(e) => {
                      // setFieldValue('stateName', undefined);
                      // const idObj = countryList.filter((res) => res.countryName === e)[0];
                      // if (idObj) {
                      //   setCountryId(idObj._id);
                      // }
                    }}
                  >
                    {countryList?.map((item) => (
                      <MenuItem
                        key={item.countryName}
                        value={item.countryName}
                      >
                        <div style={{ textTransform: 'capitalize' }}>{item.countryName}</div>
                      </MenuItem>
                    ))}
                  </FormSelectField>
                </Stack>
                <Stack>
                  <PhoneTextField
                    required
                    variant="outlined"
                    label={t("Phone number")}
                    name="phone"
                    name2="phoneNumber"
                    name3="phoneCode"
                  />
                </Stack>
                <Stack style={{ marginTop: '20px' }}>
                  <FormTextField
                    outlineLabel={t('Address')}
                    name="address"
                    requiredMark={true}
                    // onlyAlpha={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 301 }}
                  />
                </Stack>
              </Stack>
              {type === 'add' && (
                <Stack
                  style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                  className="m-[15px] p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-16"
                    color={text}
                  >
                    {t('System will automatically generate a strong password of 16 characters')}
                  </Typography>
                </Stack>
              )}

              <DialogActions
                className="!mt-[44px] h-[66px] !justify-end p-[0px] sticky bottom-[0]"
                style={{ backgroundColor: '#FFFFFF', zIndex: 1 }}
              >
                <Button
                  sx={[
                    dialogButtonCancel,
                    {
                      color: theme.palette.primary.main,
                      '&:hover': {
                        // backgroundColor: theme.palette.secondary.main,
                        // color: theme.palette.background.main,
                        // borderColor: theme.palette.secondary.main,
                      },
                    },
                  ]}
                  style={{ width: '128px', marginLeft: '80px', height: '40px' }}
                  onClick={() => {
                    onModelHandleClose(false);
                  }}
                >
                  {t('Close')}
                </Button>
                <Button
                  sx={[
                    buttonStyle2,
                    {
                      color: theme.palette.background.main,
                      backgroundColor: theme.palette.primary.dark,
                      '&:hover': {
                        // backgroundColor: theme.palette.secondary.main,
                        // color: theme.palette.background.main,
                      },
                    },
                  ]}
                  style={{ width: '128px', height: '40px',  }}
                  disabled={!(dirty && isValid)}
                  type="submit"
                  variant="contained"
                >
                  {type === 'add' ? t('Save') : t(`Update`)}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Stack>
    </Dialog>
  );
}
